import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
// css

// mui
import Tables from "components/table/table";
import { toast } from "react-toastify";
import getAllVraShiftAPIS from "apis/panel/vraShifts/vraShifts.js";
import Context from "context/context";
import Button from "@mui/material/Button";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Box from '@mui/material/Box';
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import EditIcon from '@mui/icons-material/Edit';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Margin, Padding } from "../../../../../node_modules/@mui/icons-material/index";

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { LocalizationProvider, DesktopDatePicker, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import check from "../../../../assets/images/check.png";
import cross from "../../../../assets/images/remove.png";
import leftarrow from "assets/images/arrow-right.png";
import Autocomplete from '@mui/material/Autocomplete';

// react calendar
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import Calendar from 'react-calendar'

const style = {
  position: 'absolute',
  top: '60%',
  left: '60%',
  transform: 'translate(-60%, -60%)',
  width: 600,
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  overflowY: "scroll",
};

const AddTrainee = () => {
    const { state, dispatch } = useContext(Context);
    const [roleCode] = useState(state.role.roleCode);
    const navigate = useNavigate();
    const { CreateVraTrainingDetailsAPI,getAllVraAddTrainingEmployeesAPI} = getAllVraShiftAPIS();
   
    const [status, setStatus] = useState("");
    const [batch, setBatch] = useState("");
    const [trainingStartDate, setTrainingStartDate] = useState(new Date());
    const [trainingEndDate, setTrainingEndDate] = useState(null);
    const [certificationDate, setCertificationDate] = useState(null);
    const [isTrainingCompleted, setIsTrainingCompleted] = useState(false);
    const [vraEmployees, setVraEmployees]= useState([])
    const [selectedEmployeeId, setSelectedEmployeeId] = useState(null); 
    
    const [selectedEmployee, setSelectedEmployee] = useState(null);
   
  
    
    const handleNavigation=()=>{
      navigate("/panel/trainingsetup")
    }
    
       
    const handleStatusChange = (event) => {

      setStatus(event.target.value)
  }

const handleGetAllVraEmployees = async () => {
    try {
        let res = await getAllVraAddTrainingEmployeesAPI();
        setVraEmployees(res?.data?.vraEmployeesMaster || []);
       
        }
    catch (err) {}
  };

  useEffect(()=>{
    handleGetAllVraEmployees()
  },[])
  
  
  const handleClearData= async()=>{
    
    setStatus("")
    setBatch("")
    setTrainingStartDate(new Date())
    setTrainingEndDate(null)
   setCertificationDate(null);
    setIsTrainingCompleted(false)
    setSelectedEmployee(null)
    setSelectedEmployeeId(null)
    
  }

  const handleRemoveEmployee = async (selectedEmployeeId)=>{
    const updatedEmployees = vraEmployees.filter(
    (e) => e.employeeId !== selectedEmployeeId
  );
  
 
  setVraEmployees(updatedEmployees); 
  }


  

    const handleSave= async()=>{
          try {
            if(selectedEmployeeId=='' || status=="" || batch=="" || trainingStartDate==""  ){
              return toast.error("Input fileds cannot be empty");
            }
            dispatch({ type: "SET_LOADING", payload: true });
            let value;
            value = { 
                vraEmployeeId:selectedEmployeeId,
                status: status,
                batch:batch,
                trainingStartDate:moment(trainingStartDate).format('YYYY-MM-DD'),
                trainingEndDate:trainingEndDate? moment(trainingEndDate).format('YYYY-MM-DD'):'',
                certificationDate:certificationDate?moment(certificationDate).format('YYYY-MM-DD'):'',
            };
            
            
            let res = await CreateVraTrainingDetailsAPI(value)
            
            dispatch({ type: "SET_LOADING", payload: false });

            if(res.status=="Ok"){
              handleClearData()
              handleRemoveEmployee(selectedEmployeeId)
              return toast.success("Trainee Added Successfully", { toast: "Trainee Added " });
             
            }else{
              return toast.error("Failed adding trainee");
            }
          
          } catch (err) {
            dispatch({ type: "SET_LOADING", payload: false });
          }
        };

  return (
    <div style={{backgroundColor:"white", borderRadius:"10px"}}>
     
       
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{pt:1, pl:1}}>      
      <div style={{ display: 'flex', alignItems: 'center',gap: "1%" }}>
          <div onClick={handleNavigation} style={{ cursor: 'pointer'}}>
            <img src={leftarrow} alt="Back" />
          </div>
      
        <Box className="addnewprojecthead">Add Trainee</Box>
        </div>
        </Grid>

        <Grid container sx={{mt: 2, mb: 1,pl:4 }}>
       
        </Grid>
        <Grid container spacing={2} sx={{ pl: 4,pr:5, mt: 2 }} >
      
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Box className="label">Employee Id <span style={{ color: "red" }}>*</span></Box>
         

         <Autocomplete
            id="primary-radiologist-autocomplete"
            options={vraEmployees}
            getOptionLabel={(option) => option.employeeCode || ""}
            renderInput={(params) => <TextField {...params} fullWidth />}
            isOptionEqualToValue={(option, value) => option.employeeId === value.employeeId}
            value={selectedEmployee || null} 
            onChange={(event, newValue) => {
              setSelectedEmployee(newValue);
              setSelectedEmployeeId(newValue ? newValue.employeeId : null); 
            }}
          />

        </Grid>

        
  <LocalizationProvider dateAdapter={AdapterDateFns}>
      
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box className="label">
              Training Start Date <span style={{ color: "red" }}>*</span>
            </Box>
            <DatePicker
              sx={{width:"100%"}}
              value={trainingStartDate}
              onChange={(newValue) => setTrainingStartDate(newValue)}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box className="label">
              Training End Date 
            </Box>
            <DatePicker
              sx={{width:"100%"}}
              value={trainingEndDate}
              onChange={(newValue) => setTrainingEndDate(newValue)}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </Grid>
      
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box className="label">
              Certification Date 
            </Box>
            <DatePicker
              sx={{width:"100%"}}
              value={certificationDate||null}
              onChange={(newValue) => setCertificationDate(newValue)}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </Grid>
      
      </LocalizationProvider>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box className="label">Batch <span style={{ color: "red" }}>*</span></Box>
            <TextField
              id="projectCode"
              placeholder="Enter the Batch"
              variant="outlined"
            //   disabled={true}
              fullWidth 
              value={batch}
              onChange={(e) => setBatch(e.target.value)}
            //   onChange={handleprojectcodeChange}
            />
           
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Box className="label">Status <span style={{ color: "red" }}>*</span></Box>
                    <FormControl fullWidth>
                    
                        <Select
                            labelId="status"
                            id="status"


                            defaultValue=""
                            displayEmpty


                            name="status"
                            value={status}
                            onChange={handleStatusChange}
                            inputProps={{ 'aria-label': 'Without label' }}
                            style={{ border: "2px solid #B2D4F8", color: "grey" }}
                        >
                            <MenuItem value="">
                                Select Status
                            </MenuItem>

                            <MenuItem value={'Active'}>Active</MenuItem>
                            <MenuItem value={'InActive'}>In Active</MenuItem>
                         



                        </Select>
                    </FormControl>
             
                </Grid>


      </Grid>
     

      <Grid container 
        sx={{ mt:2,pb:2}} 
        spacing={1} 
        justifyContent="center"
      >
        <Grid item xs={12} sm={4} md={2} lg={2} sx={{ ml:5}} >
          <Button fullWidth className="cancelButton" onClick={handleClearData}>
            Reset
          </Button>
        </Grid>
      
        <Grid item xs={12} sm={4} md={2} lg={2} sx={{pl:3, mr:3}}>
          <Button fullWidth className="saveButton" onClick={handleSave}>
            Save
          </Button>
        </Grid>
      </Grid>
      
      

    </div>
  )
}

export default AddTrainee